// extracted by mini-css-extract-plugin
module.exports = {"grid":"TwentyFiveFiftyTwentyFive_grid__1S5a6","twentyFiveRight":"TwentyFiveFiftyTwentyFive_twentyFiveRight__29-ZS","unauthorised":"TwentyFiveFiftyTwentyFive_unauthorised__2lCNA"};